export function inferMimeTypeFromUrl(url: string | null): string | null {
    if (!url) {
        return null
    }
    const lower = url.toLowerCase()
    if (lower.endsWith('.ico')) return 'image/x-icon'
    if (lower.endsWith('.svg')) return 'image/svg+xml'
    if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image/jpeg'
    if (lower.endsWith('.gif')) return 'image/gif'
    if (lower.endsWith('.webp')) return 'image/webp'
    return 'image/png'
}
